import { isBrowser } from '@croquiscom/web2app';

import { Dialog } from '@common/overlay-manager';

export async function handleNetworkError(error: any, retry: () => Promise<void>) {
  if (!isBrowser()) {
    return false;
  }

  const connect_fail_message_list = [
    // AOS
    'Failed to fetch',
    // IOS
    'The Internet connection appears to be offline.',
    '인터넷 연결이 오프라인 상태입니다.',
  ];

  if (error.message && connect_fail_message_list.indexOf(error.message) >= 0) {
    if (
      (await Dialog.confirm({
        title: '네트워크 연결 오류',
        message: '네트워크 연결이 원활하지 않아요.\n다시 시도해주세요!',
        ok: '다시 시도',
      })) === 'ok'
    ) {
      await retry();
    }
    return true;
  }

  return false;
}
